<template>
  <el-container class="personal">
    <el-aside width="200px">
      <el-menu
        class="el-menu-vertical-demo"
        text-color="#FFF"
        active-text-color="#FFD900"
        router
        :default-active="defaultActivePer"
      >
        <template v-for="menu in menuListPer">
          <el-menu-item :index="menu.path" class="not-children" :key="menu.id">
            <i :class="'iconfont ' + menu.iconCode"></i>
            <span slot="title">{{ menu.authName }}</span>
          </el-menu-item>
        </template>
      </el-menu>

      <div class="back">
        <div class="back-btn" @click="goCommon">
          <i class="el-icon-back"></i>返回
        </div>
      </div>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["isAdmin", "userInfo"]),
    // 个人中心
    defaultActivePer() {
      return this.$route.path.slice(10);
    },
  },
  data() {
    return {
      menuListPer: [
        {
          authName: "个人信息",
          id: "100",
          path: "info",
          iconCode: "icongeren",
        },
        {
          authName: "职业规划",
          id: "101",
          path: "plan",
          iconCode: "iconzhiye",
        },
        {
          authName: "积分报表",
          id: "102",
          path: "perscoretable",
          iconCode: "iconbaobiao",
        },

        {
          authName: "账号信息",
          id: "103",
          path: "password",
          iconCode: "iconqunfengzhanghaoshezhi",
        },
      ],
    };
  },
  created() {
    if (this.userInfo.schoolCode == "shsyfsdtxx") {
      this.menuListPer.splice(2, 1, {
        authName: "积分报表",
        id: "104",
        path: "perscoretable_ssdt",
        iconCode: "iconbaobiao",
      });
    }
  },
  methods: {
    //个人中心
    goCommon() {
      this.$router.push("/common/stu-prize");
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
// 个人中心
.personal {
  height: 100%;

  .el-aside {
    background-color: @theme-color;
    padding-top: 10px;

    .el-menu {
      background-color: @theme-color;
      border-right: none;

      /deep/.el-submenu__title {
        font-size: 15px;
      }

      .el-menu-item {
        font-size: 15px;

        i {
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          margin-right: 10px;
        }
      }
    }

    .el-menu-item.is-active {
      background-color: #fff !important;
      border-radius: 10px;
      color: @theme-color !important;

      i {
        color: @theme-color !important;
      }
    }

    .back {
      box-sizing: border-box;
      margin-top: 30px;
      width: 100%;
      height: 70px;
      padding-left: 35px;
      border-top: 1px solid #fff;

      .back-btn {
        box-sizing: border-box;
        margin-top: 20px;
        border: 1px solid #fff;
        width: 110px;
        padding: 8px 15px;
        height: 45px;
        font-size: 18px;
        font-weight: 500;
        border-radius: 45px;
        color: #fff;
        cursor: pointer;

        i {
          font-size: 25px;
          font-weight: 700;
          border-radius: 50%;
          background-color: #fff;
          color: @theme-color;
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
  }

  .el-main {
    background-color: #ecf0f1;
    padding: 12px;
  }
}
</style>
